import SummaryCardDetail from './SummaryCardDetail';
export default SummaryCardDetail;
